import { AbstractEntityStore } from '@pf/shared-services';
import { Injectable } from '@angular/core';
import { PFCoreEntities } from '@pf/shared-common';
import { UserRead } from '../../entities/user.dto';

@Injectable()
export class UserStore extends AbstractEntityStore<UserRead> {
    constructor() {
        super(PFCoreEntities.User);
    }
}
